// Fetch list

export const FETCH = 'taxRates.FETCH'
export const FETCH_STARTED = 'taxRates.FETCH_STARTED'
export const FETCH_FULFILLED = 'taxRates.FETCH_FULFILLED'
export const FETCH_REJECTED = 'taxRates.FETCH_REJECTED'
export const FETCH_CANCELLED = 'taxRates.FETCH_CANCELLED'

export const SORTING_CHANGED = 'taxRates.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'taxRates.FETCH_ONE'
export const FETCH_ONE_STARTED = 'taxRates.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'taxRates.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'taxRates.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'taxRates.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'taxRates.SAVE'
export const SAVE_STARTED = 'taxRates.SAVE_STARTED'
export const SAVE_FULFILLED = 'taxRates.SAVE_FULFILLED'
export const SAVE_REJECTED = 'taxRates.SAVE_REJECTED'
export const SAVE_CANCELLED = 'taxRates.SAVE_CANCELLED'

// Delete

export const DELETE = 'taxRates.DELETE'
export const DELETE_STARTED = 'taxRates.DELETE_STARTED'
export const DELETE_FULFILLED = 'taxRates.DELETE_FULFILLED'
export const DELETE_REJECTED = 'taxRates.DELETE_REJECTED'
export const DELETE_CANCELLED = 'taxRates.DELETE_CANCELLED'

// Export

export const EXPORT = 'taxRates.EXPORT'
export const EXPORT_FULFILLED = 'taxRates.EXPORT_FULFILLED'
